import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

/* New PRICEHUB mark: a "P" whose bowl is a search lens with a glowing hub node at its centre. */
export const LogoMarkV2 = ({ className = "h-10 w-10", glow = false }) => (
  <svg viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
    <rect x="0.5" y="0.5" width="39" height="39" rx="12" fill="#0B1020" stroke="#2A3450" />
    {glow && <circle cx="21" cy="16.5" r="11" fill="#B6FF5C" opacity="0.12" />}
    <path d="M12.5 31.5V16.5" stroke="#B6FF5C" strokeWidth="3.4" strokeLinecap="round" />
    <circle cx="20" cy="16.5" r="7.5" stroke="#B6FF5C" strokeWidth="3.4" />
    <circle cx="20" cy="16.5" r="2.4" fill="#818CF8" />
    <path d="M25.6 22.1 29.5 26" stroke="#818CF8" strokeWidth="2.6" strokeLinecap="round" />
    <circle cx="31" cy="8.5" r="1.9" fill="#F6F8FC" />
  </svg>
);

export const Wordmark = ({ className }) => (
  <span className={cn("font-display font-extrabold tracking-[-0.03em] text-ph-ink", className)}>
    PRICE<span className="text-ph-accent">HUB</span>
  </span>
);

export const LogoV2 = ({ tagline = true, className, testId = "main-nav-brand-logo" }) => (
  <Link to="/" data-testid={testId} aria-label="PRICEHUB home" className={cn("group flex items-center gap-3", className)}>
    <span className="transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-105"><LogoMarkV2 /></span>
    <span className="flex flex-col leading-none">
      <Wordmark className="text-[1.4rem]" />
      {tagline && <span className="mt-1 font-mono-ph text-[10px] uppercase tracking-[0.2em] text-ph-muted">Every Brand. Every Price List.</span>}
    </span>
  </Link>
);
